// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tia7","footer":"styles_footer__2KX66","passCodeTooltip":"styles_passCodeTooltip__rtjkA"};